import { useEffect } from "react";

import { ReceivingInvoiceDetailsViewModel } from "../../viewmodels/receiving/ReceivingInvoiceDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import AddReceivingInvoiceForm from "../../components/forms/receiving/AddReceivingInvoiceForm";
import EmptyModal from "../../components/modals/EmptyModal";

import { useParams } from "react-router-dom";

function ReceivingInvoiceDetails(props) {
  const { addSnackbar, logout } = props;

  const { receivingId } = useParams();

  const {
    emptyModal,
    setEmptyModelOpen,
    truckOptions,
    getTruckOptionsForDropdown,
    supplierOptions,
    getSupplierOptionsForDropdown,
    getProductOptionsForDropdown,
    productOptions,
    onFetchProductDetails,
    poOptions,
    receiving,
    addItemToReceiving,
    askDeleteReceivingItemById,
    updateReceivingItem,
    openDeleteItemByBarcodePopup,
    updateReceivingInvoice,
    getReceivingInvoiceDetails,
    employeeOptions,
    getEmployeeOptionsForDropdown,
    getWarehouses,
    getWarehouseLocations,
    onDeleteReceivingInvoice,
    askReturnSelectedItems,
    selectedItems,
    setSelectedItems,
    onUpdateUnitCostForReceivingItem,
    onUpdateTotalCostForReceivingItem,
    printReceivingSummaryReport,
    printReceivingDetailsReport,
    showErrorModal,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    carrierOptions,
    getCarriersForDropdown,
    reprintReceivingItem,
  } = ReceivingInvoiceDetailsViewModel(logout, receivingId, addSnackbar);

  async function getInfoForInvoice() {
    try {
      // Wait for all async functions to complete
      const results = await Promise.all([
        getTruckOptionsForDropdown(),
        getSupplierOptionsForDropdown(),
        getProductOptionsForDropdown(),
        getEmployeeOptionsForDropdown(),
        getCarriersForDropdown(),
      ]);

      // Run the final function
      getReceivingInvoiceDetails();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  useEffect(() => {
    getInfoForInvoice();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <AddReceivingInvoiceForm
          isEdit={true}
          truckOptions={truckOptions}
          productOptions={productOptions}
          supplierOptions={supplierOptions}
          onFetchProductDetails={onFetchProductDetails}
          poOptions={poOptions}
          setEmptyModelOpen={setEmptyModelOpen}
          receiving={receiving}
          getReceivingInvoiceDetails={getReceivingInvoiceDetails}
          addItemToReceiving={addItemToReceiving}
          askDeleteReceivingItemById={askDeleteReceivingItemById}
          updateReceivingItem={updateReceivingItem}
          openDeleteItemByBarcodePopup={openDeleteItemByBarcodePopup}
          updateReceivingInvoice={updateReceivingInvoice}
          employeeOptions={employeeOptions}
          getWarehouses={getWarehouses}
          getWarehouseLocations={getWarehouseLocations}
          isNewFlow={false}
          onDeleteReceivingInvoice={onDeleteReceivingInvoice}
          askReturnSelectedItems={askReturnSelectedItems}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          onUpdateUnitCostForReceivingItem={onUpdateUnitCostForReceivingItem}
          onUpdateTotalCostForReceivingItem={onUpdateTotalCostForReceivingItem}
          printReceivingSummaryReport={printReceivingSummaryReport}
          printReceivingDetailsReport={printReceivingDetailsReport}
          showErrorModal={showErrorModal}
          closed={receiving.status === 1}
          loadingRows={loadingRows}
          rowDetails={rowDetails}
          carrierOptions={carrierOptions}
          fetchSubRowDetails={fetchSubRowDetails}
          subRowDetails={subRowDetails}
          subLoadingRows={subLoadingRows}
          fetchRowDetails={fetchRowDetails}
          reprintReceivingItem={reprintReceivingItem}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceivingInvoiceDetails)
);
